import React from 'react';

const SkiIcon = (props) => {
  return (
    <img
      alt="Stok narciarski"
      src="/static/images/icons/tourist_attractions/ski.svg"
      {...props}
    />
  );
};

export default SkiIcon;
